/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Submit_Step_Review_DescInputs */

const en_directory_submit_step_review_desc = /** @type {(inputs: Directory_Submit_Step_Review_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Editorial quality check`)
};

const zh_directory_submit_step_review_desc = /** @type {(inputs: Directory_Submit_Step_Review_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`编辑质量检查`)
};

/**
* | output |
* | --- |
* | "Editorial quality check" |
*
* @param {Directory_Submit_Step_Review_DescInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_submit_step_review_desc = /** @type {((inputs?: Directory_Submit_Step_Review_DescInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Submit_Step_Review_DescInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_submit_step_review_desc(inputs)
	return zh_directory_submit_step_review_desc(inputs)
});
export { directory_submit_step_review_desc as "directory.submit.step_review_desc" }